export default __webpack_public_path__ + "static/media/transfer-internal.1d22f90d.svg";